// Mock data para Santa Casa Serviço Funerário Imediato

export const siteInfo = {
  name: "Santa Casa Serviço Funerário Imediato",
  tagline: "Serviço Funerário 24h",
  phone: "(21) 4106-4022",
  email: "contato@santacasafuneraria.com.br",
  location: "Meier, Rio de Janeiro / RJ",
  address: "Rua Enéas Galvão, 78 - Sala 201 - Méier, Rio de Janeiro - RJ",
  cep: "20775-120",
  coordinates: {
    latitude: -22.9044,
    longitude: -43.2791
  }
};

export const hero = {
  title: "Serviço Funerário Imediato 24 Horas no Meier RJ",
  subtitle: "Funerária completa, cremação, translado, velório, sepultamento e assistência funeral com atendimento emergencial",
  ctaText: "FALE CONOSCO",
  backgroundImage: "https://images.unsplash.com/photo-1610027562252-2ed79aa944d7?w=1920&q=80"
};

export const about = {
  title: "Quem somos",
  description: "A Santa Casa Serviço Funerário Imediato é referência em serviços funerários 24 horas no Rio de Janeiro. Funerária completa no Meier com cremação, translado nacional e internacional, velório, sepultamento e assistência funeral. Atendemos mais de 18.000 famílias com plantão funerário, remoção de corpo, documentação, urnas, flores e todo suporte necessário. Serviço funerário rápido, completo e humanizado.",
  image: "https://images.unsplash.com/photo-1522752622479-65eefd320386?w=800&q=80",
  ctaText: "SAIBA MAIS"
};

export const services = {
  title: "Atuação",
  subtitle: "Atuamos com um portfólio completo de serviços funerários, incluindo sepultamento, cremação, e translado nacional e internacional, sempre realizados com discrição, agilidade e absoluto respeito.",
  items: [
    {
      id: 1,
      title: "Serviços Funerários Completos (Sepultamento e Cremação)",
      description: "Realizamos cerimônias de sepultamento e cremação com total respeito e personalização. Oferecemos suporte completo: desde a documentação, escolha de urna e floral, até a coordenação da cerimônia no Meier e região.",
      image: "https://images.unsplash.com/photo-1587721865897-670ead1d828c?w=600&q=80",
      link: "/servicos/sepultamento-cremacao"
    },
    {
      id: 2,
      title: "Translado Nacional e Internacional",
      description: "Cuidamos de todo o processo de traslado com discrição e eficiência. Resolvemos a complexa documentação sanitária, diplomática e logística para transporte seguro e digno entre cidades e países.",
      image: "https://images.unsplash.com/photo-1595204538982-59dc87ae8d0f?w=600&q=80",
      link: "/servicos/translado"
    },
    {
      id: 3,
      title: "Apoio e Assessoria Familiar Integral",
      description: "Oferecemos suporte humanizado que vai além do serviço. Inclui assistência na documentação legal (certidões, benefícios), orientação emocional pós-despedida e ajuda na organização de cerimônias memoriais.",
      image: "https://images.unsplash.com/photo-1587721865940-37ebee7fb730?w=600&q=80",
      link: "/servicos/assessoria"
    }
  ]
};

export const cta = {
  title: "Solicite um atendimento",
  description: "Na Funerária do Meier, cada detalhe é pensado para oferecer conforto, dignidade e um serviço que verdadeiramente acolhe, guiando famílias com respeito desde o primeiro contato até o apoio pós-despedida.",
  ctaText: "FALE CONOSCO"
};

export const posts = {
  title: "Publicações",
  subtitle: "Artigos e informações sobre serviços funerários no Meier",
  items: [
    {
      id: 1,
      title: "Apoio Completo no Momento da Despedida",
      date: "11 de fevereiro de 2026",
      excerpt: "Com mais de 18.000 famílias atendidas no Meier e região, nossa missão é oferecer suporte integral. Do planejamento do serviço ao apoio pós-funerário, estamos ao seu lado com compaixão e profissionalismo.",
      image: "https://images.unsplash.com/photo-1604585571723-8915f3b61275?w=600&q=80",
      link: "/publicacoes/apoio-completo"
    },
    {
      id: 2,
      title: "Cremação: Uma Cerimônia de Despedida Serena e Personalizada",
      date: "11 de fevereiro de 2026",
      excerpt: "Oferecemos serviços de cremação no Meier com todo o respeito e cuidado que o momento requer. Desde a cerimônia até as opções de destino das cinzas, proporcionamos uma despedida digna.",
      image: "https://images.unsplash.com/photo-1581964268095-79e51075214d?w=600&q=80",
      link: "/cremacao"
    },
    {
      id: 3,
      title: "Translado Internacional: Cuidado e Respeito Além-Fronteiras",
      date: "11 de fevereiro de 2026",
      excerpt: "Realizamos todo o processo de traslado internacional com sensibilidade e eficiência. Cuidamos de toda a documentação, logística e protocolos necessários, assegurando que a despedida aconteça com dignidade.",
      image: "https://images.unsplash.com/photo-1649615318499-c888057747fe?w=600&q=80",
      link: "/translado"
    }
  ]
};

export const testimonials = {
  title: "Depoimentos",
  items: [
    {
      id: 1,
      name: "Ana Lúcia Mendes",
      text: "Perdi minha mãe repentinamente. A Funerária do Meier cuidou de tudo com um respeito e delicadeza que nos confortou profundamente. Mais do que um serviço, foi um verdadeiro acolhimento."
    },
    {
      id: 2,
      name: "Carlos Eduardo Ribeiro",
      text: "Precisávamos realizar o translado internacional do meu pai. A equipe foi impecável, resolvendo toda a burocracia com eficiência e nos poupando de um stress imenso num momento tão difícil."
    },
    {
      id: 3,
      name: "Fernanda Silva",
      text: "Optamos pela cremação. Todo o processo foi conduzido com serenidade e absoluto respeito aos nossos desejos. A cerimônia íntima foi perfeita. Agradecemos pelo cuidado incomparável da Funerária do Meier."
    }
  ]
};

export const footerLinks = {
  links: [
    { name: "Fale Conosco", path: "/contato" },
    { name: "Funerária no Meier", path: "/funeraria-meier" },
    { name: "Termos de Uso", path: "/termos" },
    { name: "Política de Privacidade", path: "/privacidade" }
  ],
  menu: [
    { name: "Quem Somos", path: "/quem-somos" },
    { name: "Funeral", path: "/funeral" },
    { name: "Cremação", path: "/cremacao" },
    { name: "Translado", path: "/translado" },
    { name: "Publicações", path: "/publicacoes" }
  ]
};

export const cremacaoPage = {
  title: "Serviços de Cremação no Meier",
  subtitle: "Cerimônia de Despedida Serena e Personalizada",
  hero: {
    title: "Serviço de cremação rj",
    subtitle: "Atendimento 24h com dignidade, respeito e transparência no processo de cremação",
    image: "https://images.unsplash.com/photo-1581964268095-79e51075214d?w=1920&q=80"
  },
  content: [
    {
      title: "Serviço de Cremação Completo no Rio de Janeiro",
      text: "A Santa Casa Serviço Funerário Imediato é referência em serviços de cremação no Rio de Janeiro, especialmente no Meier e regiões próximas. Atendemos mais de 18.000 famílias com profissionalismo, empatia e total transparência em cada etapa do processo de cremação. Nossa equipe especializada está disponível 24 horas por dia, 7 dias por semana, para oferecer suporte integral desde o primeiro contato até a entrega final das cinzas."
    },
    {
      title: "O que é a Cremação e Como Funciona",
      text: "A cremação é um processo funerário que transforma o corpo humano em cinzas através da exposição a altas temperaturas em câmaras especializadas chamadas fornos crematórios. Esse processo dura entre 2 a 4 horas e é realizado em crematórios certificados e licenciados pela vigilância sanitária. No Rio de Janeiro, a cremação é uma escolha cada vez mais comum por razões culturais, religiosas, ambientais e econômicas. Na Santa Casa Serviço Funerário Imediato, todo o processo é conduzido com o máximo respeito e dignidade, seguindo rigorosamente todas as normas legais e sanitárias vigentes."
    },
    {
      title: "Documentação Necessária para Cremação no RJ",
      text: "Para realizar a cremação no Rio de Janeiro, é necessário apresentar alguns documentos essenciais. Nossa equipe auxilia a família em todo o processo burocrático, garantindo agilidade e menos preocupação em um momento tão delicado. Os documentos incluem: certidão de óbito emitida por médico legista ou médico assistente, autorização da família (cônjuge, filhos ou pais), documento de identidade do falecido, autorização judicial (em casos específicos), e declaração de não oposição de familiares. Cuidamos de toda a tramitação junto aos órgãos competentes, cartórios e crematórios certificados."
    },
    {
      title: "Cerimônia de Despedida Antes da Cremação",
      text: "Entendemos que cada família tem sua forma única de se despedir. Por isso, oferecemos cerimônias personalizadas de acordo com as crenças, tradições e desejos da família. Você pode optar por uma cerimônia religiosa (católica, evangélica, espírita, judaica, budista, entre outras) ou uma celebração laica. Disponibilizamos capela velório equipada, coordenação de flores e homenagens, espaço para músicas e leituras, transmissão online para familiares distantes, e tempo adequado para a despedida antes do processo de cremação. Tudo isso com discrição, respeito e sensibilidade."
    },
    {
      title: "Crematórios Certificados e Processo Transparente",
      text: "Trabalhamos exclusivamente com crematórios certificados, licenciados e que seguem todas as normas ambientais e sanitárias do Rio de Janeiro. O processo de cremação é conduzido individualmente, garantindo a integridade e identificação das cinzas. Utilizamos sistemas de rastreamento e identificação durante todo o processo, assegurando total transparência e confiança. A família pode, se desejar, acompanhar o início do processo de cremação. Após a conclusão, as cinzas são cuidadosamente recolhidas, processadas e acondicionadas em urna provisória ou definitiva conforme escolha da família."
    },
    {
      title: "Opções de Destino das Cinzas",
      text: "Após a cremação, a família tem diversas opções para o destino das cinzas. Oferecemos urnas funerárias de diversos materiais (madeira, cerâmica, metal, biodegradável), jardins memoriais e columbários em cemitérios parceiros, dispersão das cinzas em locais permitidos por lei (mar, montanhas, jardins), divisão das cinzas entre familiares em urnas menores, ou criação de joias memoriais com pequena quantidade de cinzas. Nossa equipe orienta sobre a legislação vigente no Rio de Janeiro e ajuda a família a tomar a melhor decisão de acordo com os desejos do falecido e da família."
    },
    {
      title: "Valores e Formas de Pagamento",
      text: "Trabalhamos com transparência total nos valores. Oferecemos orçamento detalhado e sem custos ocultos, parcelamento facilitado em até 12x, atendemos planos de assistência funeral e seguros, e aceitamos diversas formas de pagamento. Entre em contato conosco para receber um orçamento personalizado de acordo com as necessidades e escolhas da família. Nossa prioridade é oferecer um serviço de qualidade acessível e transparente."
    },
    {
      title: "Por Que Escolher a Santa Casa Serviço Funerário Imediato",
      text: "Com mais de 18.000 famílias atendidas, somos referência em serviços funerários e cremação no Meier e em todo o Rio de Janeiro. Oferecemos atendimento 24 horas todos os dias do ano, equipe treinada e empática, estrutura completa e moderna, transparência em valores e processos, respeito a todas as religiões e culturas, suporte emocional e psicológico, e agilidade na documentação e logística. Estamos prontos para atender sua família com dignidade, respeito e profissionalismo no momento mais difícil."
    }
  ],
  benefits: [
    "Atendimento 24 horas no Meier e RJ",
    "Documentação completa sem burocracia",
    "Cerimônia personalizada conforme tradição familiar",
    "Crematórios certificados e licenciados",
    "Urnas funerárias de diversos materiais",
    "Suporte familiar integral e emocional",
    "Transparência total nos valores",
    "Parcelamento facilitado em até 12x",
    "Capela velório equipada",
    "Jardins memoriais e columbários",
    "Opção de transmissão online da cerimônia",
    "Assessoria completa na documentação"
  ],
  faqs: [
    {
      question: "Quanto tempo demora o processo de cremação?",
      answer: "O processo de cremação em si dura entre 2 a 4 horas, dependendo de fatores como o tipo de equipamento e características individuais. Após a cremação, as cinzas levam algumas horas para esfriar antes de serem processadas e acondicionadas. Todo o processo, incluindo documentação e cerimônia, pode levar de 1 a 3 dias úteis."
    },
    {
      question: "É possível fazer velório antes da cremação?",
      answer: "Sim, é totalmente possível e recomendado para que a família possa se despedir adequadamente. A Santa Casa Serviço Funerário Imediato oferece capela velório completa onde a família pode realizar a cerimônia de despedida antes da cremação, com todo o tempo necessário e suporte da nossa equipe."
    },
    {
      question: "A cremação é aceita por todas as religiões?",
      answer: "A maioria das religiões hoje aceita a cremação. A Igreja Católica, por exemplo, permite desde 1963. Religiões como o Espiritismo, Budismo e Hinduísmo tradicionalmente adotam a cremação. Algumas vertentes evangélicas e o Judaísmo ortodoxo ainda apresentam restrições. Nossa equipe respeita todas as crenças e auxilia a família conforme suas tradições religiosas."
    },
    {
      question: "O que posso fazer com as cinzas após a cremação?",
      answer: "Você tem diversas opções: manter em urna funerária em casa, depositar em columbário ou jazigo familiar, dispersar em local permitido (mar, montanhas, jardins), dividir entre familiares, criar joias memoriais, ou depositar em jardim memorial. Nossa equipe orienta sobre a legislação do Rio de Janeiro e ajuda na melhor escolha."
    },
    {
      question: "Qual o custo de um serviço de cremação no RJ?",
      answer: "O valor varia conforme os serviços escolhidos (tipo de cerimônia, urna, local do velório). A Santa Casa Serviço Funerário Imediato oferece planos completos com valores transparentes e sem custos ocultos. Entre em contato conosco 24h para receber um orçamento personalizado e detalhado. Oferecemos parcelamento facilitado."
    },
    {
      question: "Preciso de autorização judicial para cremar?",
      answer: "Na maioria dos casos não é necessária autorização judicial. A cremação pode ser realizada com a documentação padrão e autorização dos familiares diretos. A autorização judicial é necessária apenas em casos específicos, como quando há suspeita sobre a causa da morte ou contestação familiar. Nossa equipe avalia cada caso e orienta sobre a documentação necessária."
    },
    {
      question: "Quanto tempo leva para receber as cinzas?",
      answer: "Normalmente, as cinzas são entregues à família entre 24 a 48 horas após a cremação, já acondicionadas em urna provisória ou na urna definitiva escolhida pela família. O prazo pode variar conforme a disponibilidade do crematório e o tempo necessário para processar a documentação."
    },
    {
      question: "A cremação é mais econômica que o sepultamento tradicional?",
      answer: "Geralmente sim. A cremação elimina custos como jazigo perpétuo, manutenção de túmulo, e taxas cemiteriais anuais. Além disso, a família tem mais flexibilidade no destino das cinzas. A Santa Casa Serviço Funerário Imediato oferece planos de cremação com excelente custo-benefício e condições facilitadas de pagamento."
    }
  ]
};

export const transladoPage = {
  title: "Serviços de Translado no Meier",
  subtitle: "Translado Nacional e Internacional",
  hero: {
    title: "Translado",
    subtitle: "Cuidado e respeito além-fronteiras",
    image: "https://images.unsplash.com/photo-1595204538982-59dc87ae8d0f?w=1920&q=80"
  },
  content: [
    {
      title: "Translado Nacional",
      text: "Realizamos o transporte seguro e digno para qualquer cidade do Brasil. A Santa Casa Serviço Funerário Imediato cuida de toda a logística, documentação sanitária e autorização necessária para o translado nacional, garantindo agilidade e respeito em todo o processo."
    },
    {
      title: "Translado Internacional",
      text: "Cuidamos de todo o processo de traslado internacional com sensibilidade e eficiência. Resolvemos a complexa documentação sanitária, diplomática e consular, coordenamos com companhias aéreas e agências funerárias no país de destino, assegurando que a despedida aconteça com dignidade."
    },
    {
      title: "Documentação e logística",
      text: "Nossa equipe especializada resolve toda a burocracia: certidões, autorizações sanitárias, documentação consular, embalsamamento quando necessário, preparação de urna apropriada para transporte aéreo, coordenação com companhias aéreas e acompanhamento em tempo real."
    }
  ],
  benefits: [
    "Atendimento 24h no Meier",
    "Translado nacional e internacional",
    "Documentação completa",
    "Coordenação com consulados",
    "Acompanhamento em tempo real",
    "Suporte multilíngue"
  ]
};
